export default __webpack_public_path__ + "static/media/skovstykket-floorplans-apartment-3-09.286c2c0b.jpg";